import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useLayout} from '../../../core/LayoutProvider'
import {usePageData} from '../../../core/PageData'

/**
 * Toolbar page title — Users List style:
 * - light: dark #1f2937 on page background (not white-on-blue hero)
 * - dark: white
 */
const DefaultTitle: FC = () => {
  const {pageTitle, pageDescription, pageBreadcrumbs, pageTitleActions} = usePageData()
  const {config, attributes} = useLayout()
  if (!pageTitle && (!pageBreadcrumbs || pageBreadcrumbs.length === 0) && !pageTitleActions) {
    return null
  }
  return (
    <div className='d-flex align-items-center justify-content-between flex-grow-1 gap-2 flex-wrap ss-toolbar-title-wrap'>
      <div {...attributes.pageTitle} className='page-title d-flex flex-column ss-toolbar-page-title'>
        {/* begin::Title */}
        {pageTitle && (
          <h1 className='d-flex ss-toolbar-page-title__heading fw-bold my-1 fs-2'>
            {pageTitle}
            {pageDescription && config.pageTitle && config.pageTitle.description && (
              <>
                <span className='h-20px border-gray-300 border-start ms-3 mx-2'></span>
                <small className='ss-toolbar-page-title__desc fs-7 fw-semibold my-1 ms-1'>{pageDescription}</small>
              </>
            )}
          </h1>
        )}
        {/* end::Title */}

        {pageBreadcrumbs &&
          pageBreadcrumbs.length > 0 &&
          config.pageTitle &&
          config.pageTitle.breadCrumbs && (
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 ss-toolbar-page-title__crumbs'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li className='breadcrumb-item ss-toolbar-page-title__crumb' key={`${item.path}${index}`}>
                  {!item.isSeparator ? (
                    <Link className='ss-toolbar-page-title__crumb-link' to={item.path}>
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bullet bg-gray-400 opacity-75 w-5px h-2px'></span>
                  )}
                </li>
              ))}
              <li className='ss-toolbar-page-title__crumb ss-toolbar-page-title__crumb--current'>{pageTitle}</li>
            </ul>
          )}
      </div>
      {pageTitleActions && (
        <div className='d-flex align-items-center ms-auto ss-toolbar-actions'>
          {pageTitleActions}
        </div>
      )}
    </div>
  )
}

export {DefaultTitle}
